module.exports = __webpack_public_path__ + "img/house-selection.64ddb8c0.png";